<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <div id="edm-status">
            {{ form.status }}
          </div>
          <el-button
            :disabled="isSaving"
            size="mini"
            type="success"
            icon="el-icon-s-promotion"
            @click="handleTest"
          >
            Test
          </el-button>
          <el-button
            :disabled="isLoading"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="!canSave"
            size="mini"
            type="primary"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <div v-loading="isLoading">
      <el-form
        ref="form"
        :disabled="isLoading"
        :model="form"
        class="round-border-form"
        label-position="top"
        label-width="200"
      >
        <el-form-item 
          v-if="isEditMode"
          prop="instruction"
        >
          <span slot="label">Instruction</span>
          <el-input 
            type="textarea" 
            v-model="instruction"
            autosize
          />
        </el-form-item>


        <el-form-item 
          v-if="isEditMode"
          prop="showImages"
        >
          <span slot="label">Show Images</span>
          <el-switch v-model="showImages">
        </el-form-item>

        <el-button
          v-if="isEditMode"
          size="mini"
          type="primary"
          style="margin-bottom: 8px;"
          @click="handleGenerateContent"
        >
          Generate Content
        </el-button>

        <el-form-item
          label="Subject"
          prop="subject"
        >
          <el-input
            v-model="form.subject"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Preview Text"
          prop="preview_text"
        >
          <el-input
            v-model="form.preview_text"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Publish At"
          prop="publish_at"
        >
          <el-date-picker
            v-model="form.publish_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="Publish At"
          >
          </el-date-picker>
        </el-form-item>

        <el-button
          v-if="form.marketing_u1 === ''"
          size="mini"
          type="primary"
          style="margin-bottom: 8px;"
          :disabled="form.publish_at === ''"
          @click="handleGenerateMarketingU1"
        >
          Generate U1
        </el-button>

        <el-form-item
          v-else
          prop="marketing_u1"
        >
          <div><b>Marketing U1: </b>{{form.marketing_u1}}</div>
        </el-form-item>

        <el-form-item 
          v-if="isEditMode"
          prop="has_long_product_name"
        >
          <span slot="label">Has Long Product Name?</span>
          <el-switch v-model="form.has_long_product_name">
        </el-form-item>

        <el-form-item
          v-if="canUpdateStatus"
          label="Status"
          prop="status"
        >
          <el-radio 
            v-model="form.status" 
            label="draft"
          >
            Draft
          </el-radio>
          
          <el-radio 
            v-model="form.status"
            label="scheduled"
          >
            Scheduled
          </el-radio>
        </el-form-item>

        <el-form-item
          v-else
          label="Status"
          prop="status"
        >
          <el-input
            v-model="form.status"
            :disabled="true"
          />
        </el-form-item>

        <div v-for="section in form.sections">
          <h4 class="title">Section {{ section.sort }}</h4>

          <el-form-item
            label="Main Store"
            prop="mainSelectedStore"
          >
            <gx-select
              v-model="section.mainSelectedStore"
              :show-label="false"
              :options="stores"
              track-by="id"
              label="name"
            >
              <template #selectedLabel="{ option }">{{ option.name }}</template>
              <template #option="{ option }">
                <div class="d-flex justify-content-space-between">
                  <span>{{ option.name }} ({{ option.gx_deeplink_advertiser_id }})</span>
                  <span style="color: #F56C6C">{{ option.gx_deeplink_affiliate }}</span>
                </div>
              </template>
            </gx-select>
          </el-form-item>

          <el-form-item
            label="Override Main Marketing U1?"
            prop="isOverrideMainMarketingU1"
          >
            <el-switch v-model="section.isOverrideMainMarketingU1">
          </el-form-item>

          <el-form-item
            v-if="section.isOverrideMainMarketingU1"
            prop="main_marketing_u1"
          >
            <el-input
              v-model="section.main_marketing_u1"
              placeholder="Main Marketing U1"
              clearable
            />
          </el-form-item>

          <el-form-item 
            v-if="showImages"
            prop="main_image_url"
          >
            <img 
              :src="section.main_image_url"
              style="max-width: 600px;"
            />
          </el-form-item>

          <el-form-item prop="main_image_url">
            <el-input
              v-model="section.main_image_url"
              placeholder="Main Image URL"
              clearable
            />
          </el-form-item>

          <el-form-item prop="main_long_url">
            <el-input
              v-model="section.main_long_url"
              placeholder="Main URL"
              clearable
            />
          </el-form-item>

          <el-form-item prop="main_url">
            <div>{{section.main_url}}</div>
          </el-form-item>

          <el-form-item prop="product_currency">
            <el-input
              v-model="section.product_currency"
              placeholder="Product Currency"
              clearable
            />
          </el-form-item>

          <br/>

          <div v-for="dealPostProduct in section.dealPostProducts" class="">
            <div>{{ dealPostProduct.name }}</div>
            <el-button
              v-for="i in 3"
              :key="i"
              size="mini"
              type="success"
              @click="handleSelectProduct(dealPostProduct, section, i - 1)"
            >
              #{{ i }}
            </el-button>
          </div>

          <div v-for="product in section.products" class="edm-row-div">
            <div class="edm-product-div">
              <div class="edm-product-title">Product #{{ product.sort }}</div>

              <el-form-item prop="brand_name">
                <el-input
                  v-model="product.brand_name"
                  placeholder="Brand Name"
                  clearable
                />
              </el-form-item>
              
              <el-form-item prop="name">
                <el-input
                  v-model="product.name"
                  placeholder="Name"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="list_price">
                <el-input
                  v-model="product.list_price"
                  placeholder="List Price"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="sale_price">
                <el-input
                  v-model="product.sale_price"
                  placeholder="Sale Price"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="discount_rate">
                <el-input
                  v-model="product.discount_rate"
                  placeholder="Discount Rate"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="image_url">
                <el-input
                  v-model="product.image_url"
                  placeholder="Image URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="long_url">
                <el-input
                  v-model="product.long_url"
                  placeholder="URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="url">
                <div>{{product.url}}</div>
              </el-form-item>
            </div>
          </div>

          <div class="edm-clearfix"/>

          <div class="edm-row-div">
            <div class="edm-2-image-div">
              <div class="edm-product-title">Left Store</div>

              <el-form-item prop="leftSelectedStore">
                <gx-select
                  v-model="section.leftSelectedStore"
                  :show-label="false"
                  :options="stores"
                  track-by="id"
                  label="name"
                >
                  <template #selectedLabel="{ option }">{{ option.name }}</template>
                  <template #option="{ option }">
                    <div class="d-flex justify-content-space-between">
                      <span>{{ option.name }} ({{ option.gx_deeplink_advertiser_id }})</span>
                      <span style="color: #F56C6C">{{ option.gx_deeplink_affiliate }}</span>
                    </div>
                  </template>
                </gx-select>
              </el-form-item>

              <el-form-item
                label="Override Left Marketing U1?"
                prop="isOverrideLeftMarketingU1"
              >
                <el-switch v-model="section.isOverrideLeftMarketingU1">
              </el-form-item>

              <el-form-item
                v-if="section.isOverrideLeftMarketingU1"
                prop="left_marketing_u1"
              >
                <el-input
                  v-model="section.left_marketing_u1"
                  placeholder="Left Marketing U1"
                  clearable
                />
              </el-form-item>

              <el-form-item 
                v-if="showImages"
                prop="left_image_url"
              >
                <img 
                  :src="section.left_image_url"
                  style="max-width: 300px;"
                />
              </el-form-item>

              <el-form-item prop="left_image_url">
                <el-input
                  v-model="section.left_image_url"
                  placeholder="Left Image URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="left_long_url">
                <el-input
                  v-model="section.left_long_url"
                  placeholder="Left URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="left_url">
                <div>{{section.left_url}}</div>
              </el-form-item>
            </div>

            <div class="edm-2-image-div">
              <div class="edm-product-title">Right Store</div>

              <el-form-item prop="rightSelectedStore">
                <gx-select
                  v-model="section.rightSelectedStore"
                  :show-label="false"
                  :options="stores"
                  track-by="id"
                  label="name"
                >
                  <template #selectedLabel="{ option }">{{ option.name }}</template>
                  <template #option="{ option }">
                    <div class="d-flex justify-content-space-between">
                      <span>{{ option.name }} ({{ option.gx_deeplink_advertiser_id }})</span>
                      <span style="color: #F56C6C">{{ option.gx_deeplink_affiliate }}</span>
                    </div>
                  </template>
                </gx-select>
              </el-form-item>

              <el-form-item
                label="Override Right Marketing U1?"
                prop="isOverrideRightMarketingU1"
              >
                <el-switch v-model="section.isOverrideRightMarketingU1">
              </el-form-item>

              <el-form-item
                v-if="section.isOverrideRightMarketingU1"
                prop="right_marketing_u1"
              >
                <el-input
                  v-model="section.right_marketing_u1"
                  placeholder="Right Marketing U1"
                  clearable
                />
              </el-form-item>

              <el-form-item 
                v-if="showImages"
                prop="right_image_url"
              >
                <img 
                  :src="section.right_image_url"
                  style="max-width: 300px;"
                />
              </el-form-item>

              <el-form-item prop="right_image_url">
                <el-input
                  v-model="section.right_image_url"
                  placeholder="Right Image URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="right_long_url">
                <el-input
                  v-model="section.right_long_url"
                  placeholder="Right URL"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="right_url">
                <div>{{section.right_url}}</div>
              </el-form-item>
            </div>
          </div>

          <br/>

          <div class="edm-clearfix"/>
        </div>
      </el-form>
    </div>
  </sticky-header-layout>
</template>

<script>
import { reactive } from '@vue/composition-api'

import EdmService from '../../api/edm'
import DealPostService from '../../api/deal-post'
import { getAffiliateStoresWithPaging } from '../../api/stores'

import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'
import { i18n } from '@/lang'
import { formatDatetime } from '../../utils/datetime'

export default {
  name: 'RegularEdmDetail',
  components: {
    ListPageHeader,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      isLoading: true,
      showImages: false,
      stores: [],
      instruction: '',
      form: {
        subject: '',
        preview_text: '',
        confirmed_by: 0,
        publish_at: '',
        marketing_u1: '',
        has_long_product_name: 0,
        status: '',
        sections: [],
      },
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await getAffiliateStoresWithPaging({ size: 9999, is_deeplink: 1 })
      next((vm) => { vm._data.stores = response.data.stores }) // eslint-disable-line no-underscore-dangle
    } catch (error) {
      next(new Error('Could not get store list'))
    }
  },
  computed: {
    isEditMode() {
      return !!this.id
    },
    canUpdateStatus() {
      return this.form.confirmed_by > 0 && (this.form.status === 'draft' || this.form.status === 'scheduled')
    },
    canSave() {
      return !this.loading && !(this.form.status === 'sending' || this.form.status === 'completed') && this.form.marketing_u1 !== ''
    },
  },
  mounted() {
    for (let i = 0; i < 2; i++) {
      let section = {
        mainSelectedStore: null,
        leftSelectedStore: null,
        rightSelectedStore: null,
        isOverrideMainMarketingU1: false,
        isOverrideLeftMarketingU1: false,
        isOverrideRightMarketingU1: false,
        main_store_id: 0,
        main_marketing_u1: '',
        main_long_url: '',
        main_url: '',
        main_image_url: '',
        left_store_id: 0,
        left_marketing_u1: '',
        left_long_url: '',
        left_url: '',
        left_image_url: '',
        right_store_id: 0,
        right_marketing_u1: '',
        right_long_url: '',
        right_url: '',
        right_image_url: '',
        sort: i + 1,
        product_currency: 'HK$',
        products: [],
        dealPostProducts: []
      }

      for (let j = 0; j < 3; j++) {
        section.products.push({
          name: '',
          image_url: '',
          brand_name: '',
          list_price: '',
          sale_price: '',
          discount_rate: '',
          store_id: 0,
          marketing_u1: '',
          long_url: '',
          url: '',
          sort: j + 1,
        })
      }

      this.form.sections.push(section)
    }

    if (this.isEditMode) {
      this.getDetail(this.id) 
    } else {
      this.isLoading = false
    }
  },
  methods: {
    formatDatetimeToUTC(date) {
      return formatDatetime({ date: date, timezoneOffset: -8})
    },
    async getDetail() {
      this.isLoading = true

      try {
        const response = await EdmService.getRegularEdmDetail(this.id)
        const { data } = response

        this.form.subject = data.subject
        this.form.preview_text = data.preview_text
        this.form.confirmed_by = data.confirmed_by
        this.form.publish_at = data.publish_at ? formatDatetime({date: data.publish_at}) : ''
        this.form.marketing_u1 = data.marketing_u1
        this.form.has_long_product_name = data.has_long_product_name
        this.form.status = data.status

        for (let i = 0; i < data.sections.length; i++) {
          if (i < this.form.sections.length) {
            this.form.sections[i].main_store_id = data.sections[i].main_store_id
            this.form.sections[i].main_marketing_u1 = data.sections[i].main_marketing_u1
            this.form.sections[i].main_long_url = data.sections[i].main_long_url
            this.form.sections[i].main_url = data.sections[i].main_url
            this.form.sections[i].main_image_url = data.sections[i].main_image_url

            this.form.sections[i].left_store_id = data.sections[i].left_store_id
            this.form.sections[i].left_marketing_u1 = data.sections[i].left_marketing_u1
            this.form.sections[i].left_long_url = data.sections[i].left_long_url
            this.form.sections[i].left_url = data.sections[i].left_url
            this.form.sections[i].left_image_url = data.sections[i].left_image_url

            this.form.sections[i].right_store_id = data.sections[i].right_store_id
            this.form.sections[i].right_marketing_u1 = data.sections[i].right_marketing_u1
            this.form.sections[i].right_long_url = data.sections[i].right_long_url
            this.form.sections[i].right_url = data.sections[i].right_url
            this.form.sections[i].right_image_url = data.sections[i].right_image_url

            this.form.sections[i].mainSelectedStore = this.getStore(data.sections[i].main_store_id)
            this.form.sections[i].leftSelectedStore = this.getStore(data.sections[i].left_store_id)
            this.form.sections[i].rightSelectedStore = this.getStore(data.sections[i].right_store_id)

            this.form.sections[i].isOverrideMainMarketingU1 = (data.sections[i].main_marketing_u1 !== '')
            this.form.sections[i].isOverrideLeftMarketingU1 = (data.sections[i].left_marketing_u1 !== '')
            this.form.sections[i].isOverrideRightMarketingU1 = (data.sections[i].right_marketing_u1 !== '')

            this.form.sections[i].product_currency = data.sections[i].product_currency

            for (let j = 0; j < data.sections[i].products.length; j++) {
              if (j < this.form.sections[i].products.length) {
                this.form.sections[i].products[j].name = data.sections[i].products[j].name
                this.form.sections[i].products[j].image_url = data.sections[i].products[j].image_url
                this.form.sections[i].products[j].brand_name = data.sections[i].products[j].brand_name
                this.form.sections[i].products[j].list_price = data.sections[i].products[j].list_price
                this.form.sections[i].products[j].sale_price = data.sections[i].products[j].sale_price
                this.form.sections[i].products[j].discount_rate = data.sections[i].products[j].discount_rate
                this.form.sections[i].products[j].long_url = data.sections[i].products[j].long_url
                this.form.sections[i].products[j].url = data.sections[i].products[j].url
              }
            }
          }
        }
        
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    getStore(id) {
      let store = null

      this.stores.forEach(thisStore => {
        if (thisStore.id === id) {
          store = thisStore
        }
      })

      return store
    },
    async createRegularEdm(form) {
      this.isLoading = true

      try {
        const result = await EdmService.createRegularEdm(form)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async updateRegularEdm(id, form) {
      this.isLoading = true

      try {
        const result = await EdmService.updateRegularEdm(id, form)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async testRegularEdm(id) {
      this.isLoading = true

      try {
        const result = await EdmService.testRegularEdm(id)
        this.handleTestSuccess()

        // Save immediately
        this.form.status = 'scheduled'
        this.handleSave()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async generateMarketingU1(date) {
      this.isLoading = true

      const now = Date.now()

      const payload = {
        name: `edm_${date}_${now}`,
        country_code: 'HK',
        date: date,
        store_type: 'affiliate',
        advertising_platform_id: 7,
        type_id: 2,
        store_id: 0,
        brand_name: '',
        is_cpc: 0,
      }

      const response = await DealPostService.create(payload)
      const { data } = response

      this.form.marketing_u1 = data.marketing_u1

      this.isLoading = false

      // Save immediately
      this.handleSave()
    },
    async searchDealPosts(names, targetDate) {
      this.isLoading = true

      const response = await DealPostService.search(names, targetDate)
      const { data } = response

      this.isLoading = false

      return data
    },
    hasInvalidLink(storeId, links) {
      let hasInvalidLink = false
      let validationTexts = []

      const store = this.getStore(storeId)

      if (store) {
        validationTexts = store.validation_text.split(',')
      }

      if (validationTexts.length > 0) {
        links.forEach(link => {
          if (link !== '') {
            const matchWithStoreDomain = !!validationTexts.find(text => link.toLowerCase().includes(text.toLowerCase()))

            if (!matchWithStoreDomain) {
              hasInvalidLink = true
            }
          }
        })
      }

      return hasInvalidLink
    },
    async handleSave() {
      try {
        await this.$refs.form.validate()

        if (this.form.publish_at) {
          this.form.publish_at = this.formatDatetimeToUTC(this.form.publish_at)
        }

        if (this.form.marketing_u1 === '') {
          this.handleSaveFail('Please generate marketing u1.')
          return
        }

        let hasInvalidLink = false

        for (let i = 0; i < this.form.sections.length; i++) {
          if (this.form.sections[i].mainSelectedStore) {
            const mainStoreId = this.form.sections[i].mainSelectedStore.id

            this.form.sections[i].main_store_id = mainStoreId

            for (let j = 0; j < this.form.sections[i].products.length; j++) {
              this.form.sections[i].products[j].store_id = mainStoreId
            }

            // Check Links

            let mainLinks = []

            mainLinks.push(this.form.sections[i].main_long_url)

            this.form.sections[i].products.forEach(product => {
              mainLinks.push(product.long_url)
            })

            if (this.hasInvalidLink(mainStoreId, mainLinks)) {
              hasInvalidLink = true
            }
          }

          if (this.form.sections[i].leftSelectedStore) {
            const leftStoreId = this.form.sections[i].leftSelectedStore.id

            this.form.sections[i].left_store_id = leftStoreId

            if (this.hasInvalidLink(leftStoreId, [this.form.sections[i].left_long_url])) {
              hasInvalidLink = true
            }
          }

          if (this.form.sections[i].rightSelectedStore) {
            const rightStoreId = this.form.sections[i].rightSelectedStore.id

            this.form.sections[i].right_store_id = rightStoreId

            if (this.hasInvalidLink(rightStoreId, [this.form.sections[i].right_long_url])) {
              hasInvalidLink = true
            }
          }

          // Override U1

          const mainMarketingU1 = (this.form.sections[i].isOverrideMainMarketingU1) ? this.form.sections[i].main_marketing_u1 : ''

          this.form.sections[i].main_marketing_u1 = mainMarketingU1

          for (let j = 0; j < this.form.sections[i].products.length; j++) {
            this.form.sections[i].products[j].marketing_u1 = mainMarketingU1
          }

          if (!this.form.sections[i].isOverrideLeftMarketingU1) {
            this.form.sections[i].left_marketing_u1 = ''
          }

          if (!this.form.sections[i].isOverrideRightMarketingU1) {
            this.form.sections[i].right_marketing_u1 = ''
          }
        }

        if (hasInvalidLink) {
          this.handleSaveFail('Some URLs do not match the selected store.')
          return
        }

        // Handle one line product price stuff

        for (let i = 0; i < this.form.sections.length; i++) {
          for (let j = 0; j < this.form.sections[i].products.length; j++) {
            let product = this.form.sections[i].products[j]

            let listPrice = product.list_price
            let salePrice = product.sale_price
            let discountRate = product.discount_rate

            listPrice = listPrice.replaceAll('HKD', '')
            listPrice = listPrice.replaceAll('HK$', '')
            listPrice = listPrice.replace('$', '')

            let listPriceComponents = listPrice.split('|')

            if (listPriceComponents.length > 0) {
              listPrice = listPriceComponents[0]

              if (salePrice === '') {
                salePrice = listPriceComponents[1]
              }

              if (discountRate === '' && listPriceComponents.length > 1) {
                discountRate = listPriceComponents[2]
              }
            }

            this.form.sections[i].products[j].list_price = listPrice
            this.form.sections[i].products[j].sale_price = salePrice
            this.form.sections[i].products[j].discount_rate = discountRate
          }
        }

        if (this.isEditMode) {
          this.updateRegularEdm(this.id, this.form)
        } else {
          this.createRegularEdm(this.form)
        }
      } catch (error) {
        this.$alert('Please fill in all the required information.', 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
    async handleTest() {
      try {
        await this.$refs.form.validate()

        if (this.isEditMode) {
          let shortUrlCount = 0

          this.form.sections.forEach(section => {
            if (section.main_url !== '') {
              shortUrlCount++
            }

            if (section.left_url !== '') {
              shortUrlCount++
            }

            if (section.right_url !== '') {
              shortUrlCount++
            }

            section.products.forEach(product => {
              if (product.url !== '') {
                shortUrlCount++
              }
            })
          })

          if (shortUrlCount === 12) {
            this.testRegularEdm(this.id)
          } else {
            this.$confirm(`Some of the links are not shorten yet, confirm to send test email?`, 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
            }).then(() => {
              this.testRegularEdm(this.id)
            }).catch(() => {
            })
          }
        }
      } catch (error) {
        this.$alert('Please fill in all the required information.', 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
    handleCancel() {
      this.$router.push({ path: `/edm/list-regular-edm` })
    },
    handleGenerateMarketingU1() {
      if (this.form.publish_at !== '') {
        const date = this.form.publish_at.substring(0, 10)
        this.generateMarketingU1(date)
      }
    },
    async handleGenerateContent() {
      let sections = []

      for (let i = 0; i < 2; i++) {
        sections.push({
          main: '',
          left: '',
          right: '',
        })
      }

      if (this.instruction !== '' && this.form.publish_at !== '') {
        let rows = this.instruction.split('\n').map(item => item.trim())

        for (let i = 0; i < rows.length; i++) {
          if ((i + 1) < rows.length) {
            let value = rows[i + 1]

            switch (rows[i]) {
            case 'Main EDM Subject':
              this.form.subject = value
              break
            case 'Sub-title':
              this.form.preview_text = value
              break
            case 'Top large banner':
              sections[0].main = value
              break
            case 'Middle small banner #1':
              sections[0].left = value
              break
            case 'Middle small banner #2':
              sections[0].right = value
              break
            case '2nd large banner':
              sections[1].main = value
              break
            case 'Middle small banner #3':
              sections[1].left = value
              break
            case 'Middle small banner #4':
              sections[1].right = value
              break
            default:
              break
            }
          }
        }

        const targetDate = this.form.publish_at.substring(0, 10)
        const dealPostNames = [sections[0].main, sections[0].left, sections[0].right, sections[1].main, sections[1].left, sections[1].right]

        const dealPosts = await this.searchDealPosts(dealPostNames, targetDate)

        for (let i = 0; i < sections.length; i++) {
          if (sections[i].main !== '') {
            let results = dealPosts.filter(item => item.name === sections[i].main)

            if (results.length > 0) {
              let dealPost = results[0]

              this.form.sections[i].mainSelectedStore = this.getStore(dealPost.store_id)
              this.form.sections[i].main_store_id = dealPost.store_id
              this.form.sections[i].main_long_url = dealPost.shop_now_link

              if (dealPost.products) {
                this.form.sections[i].dealPostProducts = dealPost.products
              }

              for (let j = 0; j < this.form.sections[i].products.length; j++) {
                this.form.sections[i].products[j].store_id = dealPost.store_id

                if (dealPost.brand_name && dealPost.brand_name.toLowerCase() !== 'generic') {
                  this.form.sections[i].products[j].brand_name = dealPost.brand_name
                }
              }
            }
          }

          if (sections[i].left !== '') {
            let results = dealPosts.filter(item => item.name === sections[i].left)

            if (results.length > 0) {
              let dealPost = results[0]

              this.form.sections[i].leftSelectedStore = this.getStore(dealPost.store_id)
              this.form.sections[i].left_store_id = dealPost.store_id
              this.form.sections[i].left_long_url = dealPost.shop_now_link
            }
          }

          if (sections[i].right !== '') {
            let results = dealPosts.filter(item => item.name === sections[i].right)

            if (results.length > 0) {
              let dealPost = results[0]

              this.form.sections[i].rightSelectedStore = this.getStore(dealPost.store_id)
              this.form.sections[i].right_store_id = dealPost.store_id
              this.form.sections[i].right_long_url = dealPost.shop_now_link
            }
          }
        }
      }
    },
    handleSelectProduct(dealPostProduct, section, index) {
      let brandName = section.products[index].brand_name.toLowerCase().trim()
      let productName = dealPostProduct.name.toLowerCase().trim()

      if (productName.startsWith(brandName)) {
        productName = productName.replace(`${brandName} `, '')
        section.products[index].brand_name = brandName
      }

      section.products[index].name = productName
      section.products[index].long_url = dealPostProduct.link

      window.open(dealPostProduct.link, '_blank')
    },
    handleSaveSuccess() {
      this.isLoading = false
      this.$router.push({ path: `/edm/list-regular-edm` })
    },
    handleSaveFail(error) {
      this.isLoading = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    handleTestSuccess(error) {
      this.isLoading = false
      this.$alert('The Edm has been sent to your mailbox.', 'Success', {
        confirmButtonText: 'OK',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";
@import "~@/assets/styles/table.scss";

#edm-status {
  float: left;
  margin-right: 16px;
  line-height: 30px;
  font-weight: bold;
  text-transform: uppercase;
}

.edm-row-div {
  width: 100%;
}

.edm-product-div {
  float: left;
  width: 33%;
  padding-left: 8px;
  padding-right: 8px;
}

.edm-product-title {
  font-weight: bold;
}

.edm-2-image-div {
  float: left;
  width: 50%;
  padding-left: 8px;
  padding-right: 8px;
}

.edm-clearfix {
  clear: both;
}
</style>